import React from 'react'

const HomePage = () => {
    return (
        <div>
            ErrorPage
        </div>
    );
}

export default HomePage;